import { apiSlice } from '../../../store/api/apiSlice';

export interface ArtifactDashboardRow {
  id: string;
  created_at: string;
  profile_slug: string;
  title: string;
  owner_person_id: string;
  owner_name: string;
  owner_email: string;
  member_person_id: string;
  member_name: string;
  member_email: string;
  org_id: string;
  org_name: string;
}

export interface ArtifactDashboardCoach {
  id: string;
  name: string;
  email: string;
  org_id: string;
  org_name: string;
  members_count: number;
  sessions_count: number;
}

export interface ArtifactDashboardResponse {
  artifacts: ArtifactDashboardRow[];
  coaches: ArtifactDashboardCoach[];
}

export const artifactsDashboardApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getArtifactDashboard: builder.query<ArtifactDashboardResponse, void>({
      query: () => '/admin/artifacts/dashboard',
      providesTags: ['Coaches'],
    }),
  }),
});

export const { useGetArtifactDashboardQuery } = artifactsDashboardApi;
